module.exports = __webpack_public_path__ + "media/Restaurant1192.a97abb58.mp4";